/* <cart-drawer> — slide-in cart with Section Rendering morphs.
   Depends on fetchConfig / getSectionInnerHTML / trapFocus / removeTrapFocus
   from global.js. Money is server-rendered; this file never formats currency. */
const CART_DRAWER_SECTIONS = "cart-drawer,cart-icon-bubble";

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.panel = this.querySelector("#CartDrawer");
    this.addEventListener("click", (e) => this.onClick(e));
    this.addEventListener("keyup", (e) => e.code === "Escape" && this.close());

    // In drawer mode, intercept header cart links so they open the drawer.
    if (this.dataset.cartType === "drawer") {
      document.addEventListener("click", (e) => {
        const link = e.target.closest('a[href$="/cart"], a.header__cart');
        // Ignore links inside the drawer itself (e.g. its "View cart" link).
        if (link && !link.hasAttribute("data-cart-close") && !link.closest("cart-drawer")) {
          e.preventDefault();
          this.open();
        }
      });
    }
  }

  onClick(e) {
    if (e.target.closest("[data-cart-close]")) {
      this.close();
      return;
    }
    const delta = e.target.closest("[data-qty-delta]");
    const set = e.target.closest("[data-qty-set]");
    if (!delta && !set) return;

    const row = e.target.closest("[data-line]");
    if (!row) return;
    const line = row.dataset.line;
    let qty;
    if (set) {
      qty = parseInt(set.dataset.qtySet, 10);
    } else {
      const cur = parseInt(row.querySelector(".qty__value")?.textContent, 10) || 0;
      qty = cur + parseInt(delta.dataset.qtyDelta, 10);
    }
    this.changeLine(line, Math.max(0, qty));
  }

  changeLine(line, quantity) {
    this.classList.add("is-loading");
    const body = JSON.stringify({
      line,
      quantity,
      sections: CART_DRAWER_SECTIONS,
      sections_url: window.location.pathname,
    });
    fetch(window.routes.cart_change_url, { ...fetchConfig(), body })
      .then((r) => r.json())
      .then((parsed) => this.renderContents(parsed))
      .catch(() => {})
      .finally(() => this.classList.remove("is-loading"));
  }

  renderContents(parsed) {
    const targets = [
      { id: "cart-drawer", live: "CartDrawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble", live: "cart-icon-bubble", selector: "#cart-icon-bubble" },
    ];
    targets.forEach((t) => {
      const el = document.getElementById(t.live);
      const html = parsed.sections?.[t.id];
      if (el && html != null) el.innerHTML = getSectionInnerHTML(html, t.selector);
    });
    // The /cart/add response has no item_count, so derive emptiness from the
    // freshly rendered drawer (does it contain a line item?).
    const hasItems = !!this.querySelector("#CartDrawer [data-line]");
    this.classList.toggle("is-empty", !hasItems);
    this.panel = this.querySelector("#CartDrawer");
  }

  open() {
    this.classList.add("is-open");
    document.body.classList.add("overflow-hidden");
    const focusTarget = this.querySelector("#CartDrawer [data-cart-close]") || this.panel || this;
    if (typeof trapFocus === "function") trapFocus(this, focusTarget);
  }

  close() {
    this.classList.remove("is-open");
    document.body.classList.remove("overflow-hidden");
    if (typeof removeTrapFocus === "function") removeTrapFocus();
  }
}
if (!customElements.get("cart-drawer")) customElements.define("cart-drawer", CartDrawer);
